import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PageShell } from './layout';
import Button from './Button';
import { logGaPageView } from '../analytics';

const NotFound = ({ customMessage, customTitle }) => {
  const location = useLocation();

  useEffect(() => {
    // Track 404 page views for monitoring in GA only.
    logGaPageView(location.pathname, '404 - Pagina non trovata');
  }, [location.pathname]);

  const title = customTitle || 'Ops! Questa pagina non esiste.';
  const message = customMessage || 'Forse hai sbagliato qualche lettera nell\'indirizzo? Torna alla home e riprova!';

  return (
    <PageShell>
      <div style={{ 
        maxWidth: 820, 
        margin: '80px auto', 
        padding: '0 16px', 
        textAlign: 'center' 
      }}>
        <h1 style={{ 
          fontSize: '2rem', 
          marginBottom: '1rem',
          color: '#333'
        }}>
          {title}
        </h1>
        <p style={{ 
          fontSize: '1.1rem', 
          marginBottom: '2rem',
          color: '#666'
        }}>
          {message}
        </p>
        <Button to="/" primary>
          Torna alla home
        </Button>
      </div>
    </PageShell>
  );
};

export default NotFound;
